<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true" class="cell-template"
          [ngClass]="cellClassGetter ? cellClassGetter(undefined, dataItem) : {}">
        {{getCellSummary(dataItem)}}
    </span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-single-select-control #editControl
                               [formControlValidation]="formGroup.get(column.field)"
                               [formControl]="formGroup.get(column.field)" [attr.id]="elementId"
                               [data]="data"
                               [valueField]="'value'"
                               [labelField]="'label'"
                               [overrideRequired]="overrideRequired || cellRequired(formGroup, dataItem)"
                               [readonly]="readonly || cellDisabled(formGroup, dataItem)"
                               [placeholder]="getPlaceholder(dataItem)"
                               (valueChange)="emitValueChange($event, dataItem, formGroup)"
                               [ngClass]="cellClassGetter ? cellClassGetter(formGroup, dataItem) : {}"
                               [allowClearSelectionOption]="allowClearSelectionOption"
                               [clearSelectionOptionLabel]="getClearSelectionOptionLabel(dataItem)"
                               (focussed)="columnFocusHandler(columnIndex)">
    </wbo-single-select-control>
</ng-template>
